import $ from 'jquery'

$(() => {
  // function scrollCheck() {
  //   const scroll = $(window).scrollTop()
  //   const viewportHeight = $(window).height()
  //   const headerHeight = $('#site-header').outerHeight()
  //   if (scroll > viewportHeight+headerHeight) {
  //     $('.hero-image').addClass('hidden')
  //   } else {
  //     $('.hero-image').removeClass('hidden')
  //   }
  //   if (scroll > window.innerHeight) {
  //     $('.topscroll-btn').addClass('active')
  //   } else {
  //     $('.topscroll-btn').removeClass('active')
  //   }
  // }
  // $(window).on('scroll', () => {
  //   scrollCheck()
  // })
  // scrollCheck()
  // $('a[href^="#"], a[href*="#"]').on('click', function (event) {
  //   event.preventDefault()
  //   let url = new URL(this.href)
  //   let targetPage = url.pathname
  //   let hash = url.hash
  //   if (hash && $(hash).length) {
  //     let scrollTop = $(hash).offset().top-$(window).height() * 0.1
  //     const adminBar = $('#wpadminbar')
  //     if (adminBar.length > 0) {
  //       const adminBarHeight = adminBar.outerHeight()
  //       scrollTop -= adminBarHeight
  //     }
  //     $('html, body').animate({scrollTop}, 600)
  //   } else {
  //     window.location.href = targetPage + hash
  //   }
  // })

  // if (window.location.hash) {
  //   var target = $(window.location.hash);
  //   if (target.length) {
  //     $('html, body').animate({
  //       scrollTop: target.offset().top
  //     }, 600);
  //   }
  // }
  const adminBar = $('#wpadminbar');
  if (adminBar.length > 0) {
    const adminBarHeight = adminBar.outerHeight()
    $('.fixed-header-container').css('top', `calc(${$('.fixed-header-container').css('top')} + ${adminBarHeight}px)`)
  }
})